<template>
    <div>
        <app-new-breadcrumb :routesName="$t('otherServicesRouteName')"></app-new-breadcrumb>
        <div class="main">
            <div class="description">
                <div class="description-text">
                    <h2>{{ $t("otherServicesTitle") }}</h2>
                    <!-- <p>{{ $t("otherServicesText") }}</p> -->
                </div>
                <div class="description-img">
                    <img src="../../../assets/Analize.jpg">
                </div>
            </div>
            <div class="main-part">
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle1") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText1") }}</p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle2") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText2") }}</p>
                    <div class="big-card-btn" v-b-modal.modal-container-fee>{{ $t('downloadEstimate') }}</div>
                </div>
                <b-modal id="modal-container-fee" :title="$t('otherServicesTitle2ModalTitle')"
                    @close="clearproFormaInvoiceFeesObject">
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <input class="form-control" v-model="proFormaInvoiceFees.jib"
                                v-bind:placeholder="$t('uniqeIdentificationNumberShort')"
                                v-bind:class="{ 'validation-error': $v.proFormaInvoiceFees.jib.$error }"
                                v-on:input="$v.proFormaInvoiceFees.jib.$touch()"
                                @input="proFormaInvoiceFeesJibChanged" />
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && !$v.proFormaInvoiceFees.jib.required">
                                {{
                                    $t('jibIsRequired') }}</p>
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && (!$v.proFormaInvoiceFees.jib.minLength || !$v.proFormaInvoiceFees.jib.maxLength)">
                                {{ $t('jibLengthError') }}</p>
                            <p class="small text-danger m-0"
                                v-if="$v.proFormaInvoiceFees.jib.$dirty && !$v.proFormaInvoiceFees.jib.numeric">
                                {{
                                    $t('jibAlphabetNotAllowedError') }}</p>
                            <p class="small text-success m-0"
                                v-if="proFormaFee_showLegalEntityStatus && proFormaFee_showLegalEntityNameOrError">{{
                                    legalEntityName }}</p>
                            <p class="small text-danger m-0"
                                v-else-if="proFormaFee_showLegalEntityStatus && !proFormaFee_showLegalEntityNameOrError">
                                {{
                                    $t('jibErrLegalEntityDoesntExist') }}</p>
                        </div>
                        <div class="col-lg-12 form-group">
                            <app-select v-model="proFormaInvoiceFees.type" v-bind:options="proFormaInvoiceOptions"
                                v-bind:reduce="pf => pf.code" v-bind:placeholder="$t('proFormaInvoiceChoose')"
                                class="select2" :disabled="proFormaInvoiceOptions.length == 0">
                            </app-select>
                        </div>
                        <div class="col-lg-12 form-group">
                            <div v-if="proFormaInvoiceFees.type === 'T'" class="denomination-row d-flex mb-2">
                                <span class="denomination-label col-4 p-0">{{ $t("amountKM") }}</span>
                                <div class="quantity-input col-8 p-0">
                                    <input type="number" min="0" class="form-control col-12"
                                        v-model.number="proFormaInvoiceFees.value" :placeholder="$t('amountKM')">
                                    <p class="small text-danger m-0 p-0 col-12" v-if="proFormaInvoiceFees.value < 0">
                                        {{ $t('negativeValueNotAllowed') }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="proFormaInvoiceFees.type === 'M'" class="denomination-row d-flex mb-2">
                                <span class="denomination-label col-4 p-0">{{ $t("quantity") }}</span>
                                <div class="quantity-input col-8 p-0">
                                    <input type="number" min="0" class="form-control col-12"
                                        v-model.number="proFormaInvoiceFees.quantity" :placeholder="$t('quantity')">
                                    <p class="small text-danger m-0 p-0 col-12" v-if="proFormaInvoiceFees.quantity < 0">
                                        {{ $t('negativeValueNotAllowed') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 form-group d-flex align-items-center">
                            <span class="denomination-label col-4 p-0">{{ $t("purchaseOrder") }}</span>
                            <div class="quantity-input col-8 p-0">
                                <input class="form-control col-12" v-model="proFormaInvoiceFees.purchaseOrder"
                                    :placeholder="$t('purchaseOrder')">

                            </div>
                        </div>
                        <div class="col-lg-12 form-group denomination-row d-flex align-items-center">
                            <span class="denomination-label col-4 p-0">{{ $t("purchaseOrderDate") }}</span>
                            <div class="quantity-input col-8 p-0">

                                <b-form-datepicker v-model="proFormaInvoiceFees.purchaseOrderDate" :date-format-options="{
                                    day: '2-digit',month: 'numeric',year: 'numeric',}" 
                                    :placeholder="$t('chooseDate')" locale="hr-HR" class="mb-2"></b-form-datepicker>
                                <p class="small text-danger m-0 p-0 col-12" v-if="$v && $v.proFormaInvoiceFees.purchaseOrderDate.$dirty &&
                                    !$v.proFormaInvoiceFees.purchaseOrderDate.required">
                                    {{ $t('purchaseOrderDateIsRequired') }}
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-12 form-group denomination-row d-flex align-items-center mb-2">
                            <span class="denomination-label col-4 p-0">
                                {{ $t('totalKM') }}
                            </span>
                            <input type="text" class="form-control col-8" :value="totalValue" disabled>
                        </div>
                    </div>
                    <template v-slot:modal-footer>
                        <b-button variant="secondary" @click="$bvModal.hide('modal-container-fee')">
                            {{ $t('cancel') }}
                        </b-button>
                        <b-button variant="primary" @click="downloadEstimate" :disabled="!canDownloadProForma">
                            {{ $t('download') }}
                        </b-button>
                    </template>
                </b-modal>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle3") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText3") }}</p>
                </div>
                <div class="big-card">
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle4") }}</h3>
                    </div>
                    <p>{{ $t("otherServicesText4") }}</p>
                </div>
                <div v-if="getIsAdminOrModerator" class="big-card" v-b-modal.modal-container>
                    <div class="big-card-title">
                        <i :class="`${$t('otherServicesIcon3')}`"></i>
                        <h3>{{ $t("otherServicesTitle5") }}</h3>
                    </div>
                </div>
                <b-modal v-if="getIsAdminOrModerator" id="modal-container" :cancel-title="$t('cancel')"
                    :title="$t('otherServicesTitle5')" @cancel="clearEstimateObject" @close="clearEstimateObject">
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.estimateNumber" :placeholder="$t('estimateNumber')"
                                :class="{ 'validation-error': $v.estimate.estimateNumber.$error }"
                                @input="$v.estimate.estimateNumber.$touch()" @keyup.enter="estimateNumberChanged"
                                type="text" />
                            <p class="small text-danger m-0"
                                v-if="$v.estimate.estimateNumber.$dirty && !$v.estimate.estimateNumber.required">
                                {{ $t('jibIsRequired') }}</p>
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.legalEntityName" :placeholder="$t('name')" readonly
                                class="form-control" />
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.type" :placeholder="$t('estimateType')" readonly
                                class="form-control" />
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.jib" :placeholder="$t('jib')" readonly class="form-control" />
                        </div>
                        <div class="col-md-12 form-group">
                            <input v-model="estimate.downloadDate" :placeholder="$t('downloadDate')" readonly
                                class="form-control" />
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Breadcrumb from "../../common/Breadcrumb.vue";
import Select from 'vue-select'
import { required, minLength, maxLength, numeric, requiredIf } from "vuelidate/lib/validators"

export default {
    data() {
        return {
            estimate: {
                jib: null,
                legalEntityId: null,
                downloadDate: null,
                legalEntityName: null,
                estimateNumber: null,
                estimateTypeId: null,
                type: null

            },
            proFormaInvoiceFees: {
                jib: null,
                type: null,
                value: null,
                quantity: null,
                purchaseOrder: null,
                purchaseOrderDate: null,
            },
            proFormaInvoiceOptions: [
                { label: this.$t('fee'), code: 'T' },
                { label: this.$t('billOfExchange'), code: 'M' },
            ],
            showSpinner: false,
            isLoading: false,
            legalEntityName: null,
            legalEntityId: null

        }
    },
    validations: {
        estimate: {
            jib: {
                required,
                minLength: minLength(13),
                maxLength: maxLength(13),
                numeric
            },
            estimateNumber: {
                required
            },
            downloadDate: {
                required
            },
        },
        proFormaInvoiceFees: {
            jib: {
                required,
                minLength: minLength(13),
                maxLength: maxLength(13),
                numeric
            },
            type: {
                required
            },
            quantity: {
                required,
                numeric
            },
            value: {
                required,
                numeric
            },
            purchaseOrder: {},
            purchaseOrderDate: {
                required: requiredIf(function (model) {
                    return model.purchaseOrder && model.purchaseOrder.trim() !== "";
                })
            }
        }

    },
    components: {
        appNewBreadcrumb: Breadcrumb,
        appSelect: Select,
    },
    computed: {
        ...mapGetters(["getIsAdminOrModerator"]),
        proFormaFee_showLegalEntityStatus() {
            return this.proFormaInvoiceFees.jib != null && this.proFormaInvoiceFees.jib.length == 13;
        },
        proFormaFee_showLegalEntityNameOrError() {
            return this.legalEntityName != null && this.$v.proFormaInvoiceFees.jib.$dirty && this.$v.proFormaInvoiceFees.jib.numeric && this.$v.proFormaInvoiceFees.jib.minLength && this.$v.proFormaInvoiceFees.jib.maxLength && this.$v.proFormaInvoiceFees.jib.required;
        },
        totalValue() {
            if (this.proFormaInvoiceFees.type === 'M')
                this.proFormaInvoiceFees.value = 5;

            if (this.proFormaInvoiceFees.type === 'T')
                this.proFormaInvoiceFees.quantity = 1;

            let total = this.proFormaInvoiceFees.value * this.proFormaInvoiceFees.quantity;

            return total.toLocaleString('de');
        },
        proFormaJibIsValid() {
            const jib = this.proFormaInvoiceFees.jib;
            return (
                !!jib &&
                jib.length === 13 &&
                /^\d+$/.test(jib)
            );
        },
        proFormaHasAnyQuantity() {
            return this.proFormaInvoiceFees.quantity > 0 && this.proFormaInvoiceFees.value > 0;
        },
        canDownloadProForma() {
            return (
                this.proFormaJibIsValid &&
                !!this.proFormaInvoiceFees.type &&
                this.proFormaHasAnyQuantity &&
                !this.$v.proFormaInvoiceFees.purchaseOrderDate.$error
            );
        }
    },
    methods: {
        ...mapActions(["fetchLegalEntities", "fetchEstimateByNumber", "generateEstimateFee", "fetchEstimateTypes"]),
        clearEstimateObject() {
            this.estimate.jib = null;
            this.estimate.legalEntityId = null;
            this.estimate.downloadDate = null;
            this.estimate.legalEntityName = null;
            this.estimate.estimateNumber = null;
            this.estimate.type = null;

            if (this.$v)
                this.$v.$reset();
        },
        clearproFormaInvoiceFeesObject() {
            this.proFormaInvoiceFees.jib = null;
            this.proFormaInvoiceFees.type = null
            this.proFormaInvoiceFees.quantity = null
            this.proFormaInvoiceFees.value = null
            this.proFormaInvoiceFees.purchaseOrder = null
            this.proFormaInvoiceFees.purchaseOrderDate = null

            if (this.$v)
                this.$v.$reset();
        },
        estimateNumberChanged() {
            if (!this.getIsAdminOrModerator)
                return;

            this.estimate.jib = null;
            this.estimate.legalEntityId = null;
            this.estimate.legalEntityName = null;
            this.estimate.downloadDate = null;
            this.estimate.type = null;

            this.fetchEstimateByNumber({ estimateNumber: this.estimate.estimateNumber }).then((data) => {
                if (data) {
                    this.estimate.jib = data.jib;
                    this.estimate.estimateTypeId = data.estimateTypeId;
                    if (data.downloadDate) {
                        const date = new Date(data.downloadDate);
                        this.estimate.downloadDate = date.toLocaleDateString('de');
                    } else {
                        this.estimate.downloadDate = null;
                    }
                    if (this.estimate.jib) {
                        this.fetchLegalEntities({ jib: this.estimate.jib }).then((data) => {
                            if (data.resultList && data.resultList.length > 0) {
                                this.estimate.legalEntityName = data.resultList[0].shortName || data.resultList[0].longName;
                                this.estimate.legalEntityId = data.resultList[0].id;
                            }
                        });
                    }
                    if (this.estimate.estimateTypeId) {
                        this.fetchEstimateTypes({ id: this.estimate.estimateTypeId }).then((data) => {
                            this.estimate.type = data.name;
                        });
                    }

                }
            });
        },
        downloadEstimate() {
            if (this.$v.proFormaInvoiceFees.$invalid) {
                this.$v.proFormaInvoiceFees.$touch();
                return;
            }
            this.showSpinner = true;
            this.isLoading = true;

            const payload = {
                jib: this.proFormaInvoiceFees.jib,
                type: this.proFormaInvoiceFees.type,
                quantity: this.proFormaInvoiceFees.quantity,
                value: this.proFormaInvoiceFees.value,
                purchaseOrder: this.proFormaInvoiceFees.purchaseOrder,
                purchaseOrderDate: this.proFormaInvoiceFees.purchaseOrderDate
                    ? new Date(this.proFormaInvoiceFees.purchaseOrderDate).toLocaleDateString('de-DE')
                    : null
            };
            this.generateEstimateFee(payload)
                .then((excelTemplate) => {
                    const url = URL.createObjectURL(new Blob([excelTemplate.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Predračun - ${this.proFormaInvoiceFees.jib}.docx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.clearproFormaInvoiceFeesObject();
                    this.$bvModal.hide('modal-container-fee');

                    this.showSpinner = false;
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.showSpinner = false;
                    this.isLoading = false;
                });
        },
        proFormaInvoiceFeesJibChanged() {

            this.legalEntityName = null;
            this.legalEntityId = null;

            if (this.proFormaInvoiceFees.jib.length == 13) {
                this.fetchLegalEntities({ jib: this.proFormaInvoiceFees.jib }).then((data) => {
                    if (data.resultList != null && data.resultList.length > 0) {
                        this.legalEntityName = data.resultList[0].shortName || data.resultList[0].longName;
                        this.legalEntityId = data.resultList[0].id;
                    }
                });
            }
        },
    },
    watch: {
        'proFormaInvoiceFees.type'(newType) {
            if (!newType) return;

            if (newType === 'T') {
                this.proFormaInvoiceFees.quantity = 1;
                this.proFormaInvoiceFees.value = null;
            } else if (newType === 'M') {
                this.proFormaInvoiceFees.quantity = null;
                this.proFormaInvoiceFees.value = 5;
            } else {
                this.proFormaInvoiceFees.quantity = null;
                this.proFormaInvoiceFees.value = null;
            }
        }
    }
}
</script>

<style scoped>
.big-card-title h3 {
    margin-bottom: 0;
}

.denomination-label {
    font-weight: 600;
}

.quantity-input {
    display: flex;
    flex-direction: column;
}
</style>
